import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { ctaBuyAHomeIcon, ctaGetCashIcon, ctaLowerRatesIcon } from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

export type ApplicationType = 'purchase' | 'refinance' | 'cash';

@Component({
  selector: 'ld-application-type-selector',
  imports: [MatIconModule, SvgIconComponent, TranslocoDirective],
  templateUrl: './application-type-selector.component.html',
  styleUrl: './application-type-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationTypeSelectorComponent {
  readonly isMobile = input(false);

  readonly typeSelected = output<ApplicationType>();

  readonly cancelClick = output<void>();

  protected readonly buyAHomeIcon = ctaBuyAHomeIcon;
  protected readonly getCashIcon = ctaGetCashIcon;
  protected readonly lowerPaymentsIcon = ctaLowerRatesIcon;

  protected onSelectBuyAHome(): void {
    this.typeSelected.emit('purchase');
  }

  protected onSelectGetCash(): void {
    this.typeSelected.emit('cash');
  }

  protected onSelectLowerPayments(): void {
    this.typeSelected.emit('refinance');
  }

  protected onCancel(): void {
    this.cancelClick.emit();
  }
}
